import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

import { HelperService } from '../helper.service';

// checked against the system's file-max-size setting when the control validates, so it picks the setting up once loaded
export const isFileSize =
	(): ValidatorFn =>
	(c: AbstractControl): ValidationErrors | null => {
		if (!HelperService.isFileSize(c.value)) {
			return { fileSize: true };
		}

		return null;
	};
